import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import RichTextEditor from 'components/rich-text-editor/rich-text-editor';
import FilesComponent from 'components/files/files';
const QuestionEssay = ({ questionId, initialState, instructionsFile, getLocalAnswers }) => {
    const [textAnswer, setTextAnswer] = useState();
    useEffect(() => {
        if (!initialState) {
            setTextAnswer('');
        }
        if ((initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer) !== textAnswer) {
            setTextAnswer((initialState === null || initialState === void 0 ? void 0 : initialState.userAnswer) || '');
        }
    }, [questionId]);
    return (_jsxs(_Fragment, { children: [_jsx("form", Object.assign({ className: "form--student-exam" }, { children: _jsx("fieldset", { children: _jsx("div", Object.assign({ className: "input w-100 form-controls" }, { children: textAnswer !== undefined && (_jsx(RichTextEditor, { value: textAnswer, identifier: questionId, onChange: getLocalAnswers }, void 0)) }), void 0) }, void 0) }), void 0), _jsx(FilesComponent, { file: instructionsFile }, void 0)] }, void 0));
};
export default QuestionEssay;
